import React, { useEffect, useState } from 'react'
import { reaction, comparer } from 'mobx'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import WidgetContainer from '../../WidgetContainer'
import Panel from '../../../../UniformComponents/Panel'
import EmptyStateImg from '../../../../assets/images/widget_preview.svg'
import Typography from '../../../../UniformComponents/Typography'

const WidgetPreview = ({ newWidget, dashStore }) => {
    const [chartData, setChartData] = useState()
    const [loadingData, setLoadingData] = useState(false)
    useEffect(() => {
        const { getChartData } = dashStore
        const dispose = reaction(
            () => newWidget.chartRefreshFields,
            async () => {
                const widget = newWidget.newWidgetToWidget()
                if (!widget.kpiType || !widget.chartType) return
                setLoadingData(true)
                const data = await getChartData([widget])
                newWidget.data = data
                setChartData(data)
                setLoadingData(false)
            },
            {
                equals: comparer.structural,
            },
        )
        return dispose
    }, [newWidget])

    useEffect(() => {
        const { getChartData } = dashStore
        const dispose = reaction(
            () => newWidget.chartType,
            async (newVal, oldVal) => {
                if (newVal && !oldVal) {
                    const data = await getChartData([newWidget.newWidgetToWidget()])
                    newWidget.data = data
                    setChartData(data)
                }
            },
        )
        return dispose
    }, [newWidget])
    const { questionId, formId } = newWidget.newWidgetToWidget()
    const containerKey = `${questionId}-${formId}`
    return (
        <Panel style={{ flex: '1' }}>
            <div style={{
                display: 'flex', flexDirection: 'column', height: '100%', gap: '8px',
            }}
            >
                <div>
                    <Typography type="h3">
                        {i18n.t('dashboards.widgetPreview.title')}
                    </Typography>
                    <Typography type="p">
                        {i18n.t('dashboards.widgetPreview.desc')}
                    </Typography>
                </div>
                <div style={{
                    height: '100%', width: '100%', overflow: 'hidden', flex: '1',
                }}
                >

                    <div className="previewPane" style={{ height: '100%', width: '100%' }}>
                        {chartData && !loadingData
                            ? (
                                <>
                                    <WidgetContainer
                                        renderChart
                                        chart={dashStore.getChart({
                                            ...chartData[0],
                                            title: newWidget.title,
                                            containerSize: { height: 400, width: 450 },
                                            chartType: newWidget.chartType,
                                            widgetRenderSettings: newWidget.widgetRenderSettings,
                                            kpiType: newWidget.kpiType,
                                        }, chartData[0].data)}
                                        chartKey={newWidget.chartType}
                                        title={newWidget.title}
                                        DynamicDashboardStore={dashStore}
                                        preview
                                        changeTitle={newWidget.newWidgetToWidget()}
                                        key={containerKey}
                                    />
                                    {console.log('CHART', chartData, dashStore.getChart({
                                        ...chartData[0],
                                        title: newWidget.title,
                                        containerSize: { height: 400, width: 450 },
                                        chartType: newWidget.chartType,
                                        widgetRenderSettings: newWidget.widgetRenderSettings,
                                        kpiType: newWidget.kpiType,
                                    }))}
                                </>
                            )
                            : (
                                <div className="emptyState">
                                    <img src={EmptyStateImg} alt="Chart placeholder: not enough parameters" />
                                    <Typography type="b" style={{ textAlign: 'center' }}>
                                        {i18n.t('dashboards.widgetPreview.placeholder')}
                                    </Typography>
                                </div>
                            )}
                    </div>
                </div>
            </div>
        </Panel>
    )
}

export default observer(WidgetPreview)
